import React from 'react';

function GeneralInfo({ personalInfo }) {
  const { name, emails, mobile, location, languages } = personalInfo;
  
  return (
    <div className="info-table">
      <div className="info-row">
        <div className="info-label">Full Name</div>
        <div className="info-value">{name}</div>
      </div>
      <div className="info-row">
        <div className="info-label">Email</div>
        <div className="info-value">
          {emails.map((email, i) => (
            <React.Fragment key={i}>
              <a href={`mailto:${email}`} className="info-link">{email}</a>
              {i < emails.length - 1 && <span className="email-separator"> · </span>}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="info-row">
        <div className="info-label">Mobile</div>
        <div className="info-value">{mobile}</div>
      </div>
      <div className="info-row">
        <div className="info-label">Location</div>
        <div className="info-value">{location}</div>
      </div>
      <div className="info-row">
        <div className="info-label">Languages</div>
        <div className="info-value">{languages.join(", ")}</div>
      </div>
    </div>
  );
}

export default GeneralInfo; 